import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const FeatureMultiplePortfoliosGraphic = () => (
  <StaticQuery
    query={graphql`
      query {
        single: file(relativePath: { eq: "graphics/feature-multiple-portfolios/single/graphic.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <Img fluid={data.single.childImageSharp.fluid} imgStyle={{objectFit: 'contain'}} alt="Manage multiple portfolios and create groups to view consolidated holdings"/>
      )
    }}
  />
)

export default FeatureMultiplePortfoliosGraphic
